import { setShortenEventScope } from '../actions/internalActions';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';

/**
 * Called to set the shortenEventScope property in store
 */
export default mutator(setShortenEventScope, actionMessage => {
    getStore().shortenEventScope = actionMessage.shortenEventScope;
});
